import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload } from './utils'

const API_ROOT_VER = `${API_ROOT}/v1`

// const API_ROOT_VER = 'http://localhost:9014/api/v1'

export const getProjectBaseInfo = (projectCode) => {
  // /v1/installment/project/{projectCode}
  // const API_ROOT_VER = 'http://localhost:80/api/v1'
  const url = `${API_ROOT_VER}/accounting/installment/project/${projectCode}`
  return doGet(url)
}

export const searchInstallment = (request, projectCode, period) => {
  // /api/v1/accounting/installment/search
  const url = `${API_ROOT_VER}/accounting/installment/search/${projectCode}/${period}`
  return doPost(url, request)
}

export const downloadInstallmentIncomeDetail = (pathFile) => {
  // /api​/v1​/accounting​/download​/file
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

export const downloadExpensesSubProjectVoucherListFile = (accountingSubProjectExpensesId) => {
  const url = `${API_ROOT}/files/subproject/${accountingSubProjectExpensesId}/payment/voucher/form`
  return doDownload(url)
}

export const downloadIncomeSubProjectVoucherListFile = (accountingSubProjectIncomeId) => {
  const url = `${API_ROOT}/files/subproject/${accountingSubProjectIncomeId}/reciept/voucher/form`
  return doDownload(url)
}
// จัดการงวด
export const searchPeriodManage = (id, projectCode, period) => {
  // /api/v1/accounting/period-manage/{projectCode}/{period}
  const url = `${API_ROOT_VER}/accounting/period-manage/${projectCode}/${period}?id=${id}`
  return doGet(url)
}
